<template>
  <div class="page-content">
    <OrganismsLoading v-show="isLoading" />
    <PagePartsSet v-if="!isLoading" :page-parts="pagePartsRef" />
  </div>
</template>

<script setup lang="ts">
import { PagePartsFragmentFragment } from "~/types/pageParts"
import { MetaCustomType, ScriptPropertySrc, ScriptPropertyText } from "~/types/meta"
import { useCustomMeta, createArticleJsonLD } from "~/composables/meta"
import { ApiPageOneAbsoluteUrlResponsePage } from "~/types/server/api/page"
import { useSocial } from "~/composables/useSocial"

definePageMeta({ layout: "default" })

const customMeta = useCustomMeta()
const pageRef = ref<ApiPageOneAbsoluteUrlResponsePage>()
const pagePartsRef = ref<PagePartsFragmentFragment[]>([])
const isLoading = useState<boolean>(() => true)
const route = useRoute()

const { fetchWithHandleRedirect } = usePageOneApi()
const absoluteUrl = `lp/${route.params.pageSlug}`
const pageOneResponse = await fetchWithHandleRedirect(absoluteUrl, route)
pageRef.value = pageOneResponse.page
// TODO: 型修正
pagePartsRef.value = pageOneResponse.page_parts as PagePartsFragmentFragment[]

const { marketingTagsEvent } = useSocial()

await useAsyncData("usePublicPagePartsManyQuery", async () => {
  isLoading.value = true

  const { setProducts } = useFetchProductForPageParts()
  await setProducts(pagePartsRef.value)
  marketingTagsEvent(pagePartsRef.value)

  isLoading.value = false
})

// meta script
const script: MetaCustomType["script"] = []
const felmatTag = { src: "https://js.crossees.com/csslp.js" }
const linkATag = { src: "https://link-ag.net/dist/p/l/index.js" }
script.push(felmatTag)
script.push(linkATag)

const metaData = computed(() => {
  const title = pageRef.value?.title || ""
  const description = pageRef.value?.description || ""
  const image = pageRef.value?.ogp_url || ""
  return {
    title,
    description,
    image,
  }
})

const metaScript = computed(() => {
  const script: (ScriptPropertyText | ScriptPropertySrc)[] = []
  const felmatTag = { src: "https://js.crossees.com/csslp.js" }
  const linkATag = { src: "https://link-ag.net/dist/p/l/index.js" }
  script.push(felmatTag)
  script.push(linkATag)
  return script
})

useHead(
  customMeta.fetch({
    title: `${metaData.value.title}`,
    description: `${metaData.value.description}`,
    image: `${metaData.value.image}`,
    script: metaScript.value,
    robots: pageRef.value?.noindex ? "noindex" : undefined,
    jsonLDInfo: createArticleJsonLD({
      headline: pageRef.value?.title,
      image: pageRef.value?.ogp_url,
      description: pageRef.value?.description,
    }),
  }),
)
</script>
